"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _datadogHelper = require("./../../helpers/apm/datadog-helper");

/**
 * DataDog logger
 *
 * @class DataDogLogger
 */
var DataDogLogger = /*#__PURE__*/function () {
  function DataDogLogger() {
    (0, _classCallCheck2["default"])(this, DataDogLogger);
  }

  (0, _createClass2["default"])(DataDogLogger, null, [{
    key: "init",
    value:
    /**
     * called by Analytics service when its ready to send analytics
     *
     *
     * @memberOf DataDogLogger
     */
    function init() {
      (0, _datadogHelper.init)();
    }
  }]);
  return DataDogLogger;
}();

var _default = DataDogLogger;
exports["default"] = _default;